import { createSlice } from "@reduxjs/toolkit";
import { convertDateObjToServerDate, getSameMonthLastYearEnd } from "../../../../../utils/datetimeutil";

const currentMonth = new Date();
const lastYear = getSameMonthLastYearEnd(currentMonth);

const featuresLogSlice = createSlice({
  name: "feature-log",
  initialState: {
    start_month: convertDateObjToServerDate(lastYear, true),
    end_month: convertDateObjToServerDate(currentMonth, true),
    baseCode: null,
    company: { company_name: "", company_uuid: null }
  },
  reducers: {
    clearState(state) {
      state.start_month = convertDateObjToServerDate(lastYear, true);
      state.end_month = convertDateObjToServerDate(currentMonth, true);
      state.baseCode = null;
      state.company = { company_name: "", company_uuid: null };
    },
    setStartMonth(state, action) {
      state.start_month = action.payload;
    },
    setEndMonth(state, action) {
      state.end_month = action.payload;
    },
    setLocation(state, action) {
      state.baseCode = action.payload;
    },
    setCompany(state, action) {
      state.company = action.payload;
    }
  }
});

export const {
  clearState: clearFeatureLogState,
  setStartMonth: setFeatureLogStartMonth,
  setEndMonth: setFeatureLogEndMonth,
  setLocation: setFeatureLogLocation,
  setCompany: setFeatureLogCompany
} = featuresLogSlice.actions;

export default featuresLogSlice.reducer;
